import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue';
import { linkEvent } from 'intact-vue';
import { getRestProps, addStyle } from '../utils';
import { context as StepsContext } from './context';
import { Icon } from '../icon';
export default function ($props, $blocks, $__proto__) {
  var _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    _children = _this$get.children,
    title = _this$get.title,
    index = _this$get.index,
    className = _this$get.className,
    style = _this$get.style;
  var k = this.config.k;
  return _$cc(StepsContext.Consumer, {
    'children': function children(_ref) {
      var _classNameObj;
      var value = _ref.value,
        status = _ref.status,
        onChange = _ref.onChange,
        type = _ref.type;
      var selected = value === index;
      var error = selected && status === 'error';
      var done = value > index;
      var classNameObj = (_classNameObj = {}, _classNameObj[k + "-step"] = true, _classNameObj[k + "-active"] = selected, _classNameObj[k + "-done"] = done, _classNameObj[k + "-error"] = error, _classNameObj[className] = className, _classNameObj);
      return _$cv('div', _extends({}, getRestProps(_this), {
        'className': _$cn(classNameObj),
        'style': style
      }), [_$ce(2, 'div', [_$ce(2, 'div', error && type !== 'simple' ? _$cc(Icon, {
        'className': _$cn(k + "-icon-close-bold"),
        'color': 'danger'
      }) : done && (type === 'line' || type === 'line-compact') ? _$cc(Icon, {
        'className': _$cn(k + "-icon-check-bold"),
        'color': 'primary'
      }) : type !== 'simple' ? _$ce(2, 'span', index + 1, 0) : undefined, 0, _$cn(k + "-step-mark")), _$ce(2, 'div', [_$ce(2, 'div', title, 0, _$cn(k + "-step-title")), _$ce(2, 'div', _children, 0, _$cn(k + "-step-content"))], 4, _$cn(k + "-step-main"))], 4, _$cn(k + "-step-wrapper"), {
        'ev-click': linkEvent(index, onChange)
      }), _$ce(2, 'div', null, 1, _$cn(k + "-step-tail"))]);
    }
  });
}
;